import { ContentBlock, EditorState } from 'draft-js';
import * as chrono from 'chrono-node';

export default function isSkipParsingEntityIntersected(
  editorState: EditorState,
  block: ContentBlock,
  parsedFollowup: chrono.ParsedResult,
): boolean {
  const contentState = editorState.getCurrentContent();
  const followupStart = parsedFollowup.index;
  const followupEnd = followupStart + parsedFollowup.text.length;
  let isIntersected = false;

  block.findEntityRanges(
    (char) => {
      const entityKey = char.getEntity();
      const entity = entityKey !== null && contentState.getEntity(entityKey);
      const entityType = entity && entity.getType();

      return ['skipFollowupParsing', 'mention'].includes(entityType);
    },
    (begin, end) => {
      if (
        (!isIntersected && begin >= followupStart && begin <= followupEnd) ||
        (end >= followupStart && end <= followupEnd)
      ) {
        isIntersected = true;
      }
    },
  );

  return isIntersected;
}
